import React, { createContext, useContext } from 'react';
import { useReservations } from '../hooks/useReservations';

const ReservationsContext = createContext(null);

export const ReservationsProvider = ({ children }) => {
    const reservationsData = useReservations();

    return (
        <ReservationsContext.Provider value={reservationsData}>
            {children}
        </ReservationsContext.Provider>
    );
};

export const useReservationsContext = () => {
    const context = useContext(ReservationsContext);

    if (!context) {
        throw new Error('useReservationsContext debe usarse dentro de ReservationsProvider');
    }

    return context;
};

export default ReservationsContext;
